import { Accordion, AccordionDetails, AccordionSummary, Box, Button, FormControl, FormControlLabel, Radio, RadioGroup, TextField, Tooltip, Typography } from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { LocalizationProvider, TimeField } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

function MobileAccessPreferences() {

  return (
    <Box display='flex' flexDirection='row' justifyContent='center' sx={{ marginBlockEnd: '0.5rem'}}>
     <Accordion sx={{ width: '100%', boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px;'}}>
        <AccordionSummary
          expandIcon={<ArrowDownwardIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="span" variant="h6">Submissão e Acesso a Folhas de Ponto na Aplicação Mobile</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box sx={{ display: 'flex', marginBlock: '1rem'}}>
            <Box sx={{ width: '50%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start'}}>
                <Typography variant="body1">Ativar envio automático de Serviços e Folha de Ponto não submetidos, após período definido</Typography>
                <Tooltip title="Open settings" sx={{ marginBlockStart: '0.2rem', marginInlineStart: '0.5rem'}}>
                  <InfoOutlinedIcon fontSize="small"/>
                </Tooltip>
              </Box>
            </Box>
            <Box sx={{ margin: '0rem 1rem 0 1rem', width: '50%', display: 'flex', justifyContent: 'flex-start'}}>
              <RadioGroup row sx={{ justifyContent: 'center'}} defaultValue="true" name="radio-buttons-group" >
                    <FormControlLabel control={<Radio />} label="Sim"/>
                    <FormControlLabel control={<Radio />} label="Não"/>
              </RadioGroup>
              <FormControl size="small" sx={{ bgcolor: 'white', marginInlineEnd: '0.5rem' }}>
                  <TextField size="small" defaultValue="" label="Periodo máximo passado (dias)" variant="outlined" />
              </FormControl>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TimeField size="small" format="HH:mm" label="Envio após (hh:mm)" variant="outlined" />
              </LocalizationProvider>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', marginBlock: '1rem'}}>
            <Box sx={{ width: '50%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
             <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start'}}>
                <Typography variant="body1">Definir período máximo de acesso do Motorista a Serviços e Folhas de Ponto de dias passados</Typography>
                <Tooltip title="Open settings" sx={{ marginBlockStart: '0.2rem', marginInlineStart: '0.5rem' }}>
                  <InfoOutlinedIcon fontSize="small"/>
                </Tooltip>
              </Box>
            </Box>
            <Box sx={{ margin: '0rem 1rem 0 1rem', width: '50%', display: 'flex', justifyContent: 'flex-start'}}>
              <FormControl size="small" sx={{ minWidth: 180, width: '100%', bgcolor: 'white' }} fullWidth>
                  <TextField size="small" defaultValue="" label="Periodo máximo passado (dias)" variant="outlined" />
              </FormControl>
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}

export default MobileAccessPreferences;